import { Observable, BehaviorSubject } from 'rxjs';
import { MessageCenter, doLog } from '../event';
import * as socketStatus from '../const';
function SocketteWebsocket(opt = {
    url: '',
    input: null,
}) {
    const { url, input } = opt;
    const connectionStatus = new BehaviorSubject(socketStatus.WEBSOCKET_INIT);
    const messages = new Observable((observer) => {
        let inputSubscription;
        let open = false;
        let forcedClose = false;
        const closed = () => {
            if (!open) {
                return;
            }
            connectionStatus.next(socketStatus.WEBSOCKET_CLOSED);
            open = false;
        };
        connectionStatus.next(socketStatus.WEBSOCKET_OPENING);
        const ws = new WebSocket(url);
        ws.onopen = () => {
            open = true;
            connectionStatus.next(socketStatus.WEBSOCKET_OPENED);
            inputSubscription = input?.subscribe((data) => {
                ws.send(data);
            });
        };
        ws.onmessage = (message) => {
            // add by tdd
            try {
                const res = JSON.parse(message.data);
                Object.assign(res, { dataSource: 'KUAISHOU' });
                if ((res.cmd === 'notifyPrintResult' && res.taskStatus === 'failed') ||
                    (res.cmd === 'print' && res.status === 'wrong')) {
                    res.cmd = 'notifyPrintError';
                }
                MessageCenter.listen(res);
                if (res.cmd === 'notifyPrintResult' ||
                    res.cmd === 'notifyPrintError' ||
                    res.cmd === 'print') {
                    const { taskID = '' } = res;
                    const traceId = MessageCenter.getTaskById && MessageCenter.getTaskById(taskID)
                        ? MessageCenter.getTaskById(taskID)
                        : taskID;
                    doLog({
                        traceId,
                        taskID,
                        dataSource: 'KUAISHOU',
                        process: 'FRONT_END',
                        action: 'notifyPrintResultResponse',
                        accountNo: '',
                        accountName: '',
                        bizCode: res.taskID,
                        docType: 'WAY_BILL',
                        printNode: 'NORMAL',
                        status: res.taskStatus,
                        response: res,
                        errorCode: '20001',
                        errorMessage: '',
                    });
                }
            }
            catch (e) {
                console.log(e);
            }
            observer.next(message.data);
        };
        ws.onclose = (e) => {
            // prevent observer.complete() being called after observer.error(...)
            if (!open) {
                return;
            }
            closed();
            if (forcedClose) {
                connectionStatus.next(socketStatus.WEBSOCKET_COMPLETE);
                observer.complete();
            }
            else {
                connectionStatus.next(socketStatus.WEBSOCKET_ERROR);
                observer.error(new Error(e.reason));
            }
        };
        ws.onclose = (e) => {
            // prevent observer.complete() being called after observer.error(...)
            if (!open) {
                return;
            }
            closed();
            if (forcedClose) {
                connectionStatus.next(socketStatus.WEBSOCKET_COMPLETE);
                observer.complete();
            }
            else {
                connectionStatus.next(socketStatus.WEBSOCKET_ERROR);
                observer.error(new Error(e.reason));
            }
        };
        ws.onerror = (err) => {
            closed();
            connectionStatus.next(socketStatus.WEBSOCKET_ERROR);
            observer.error(err);
        };
        return () => {
            forcedClose = true;
            if (inputSubscription) {
                inputSubscription.unsubscribe();
            }
            if (open) {
                closed();
                ws.close();
            }
        };
    });
    return { messages, connectionStatus };
}
export default SocketteWebsocket;
